import { render, staticRenderFns } from "./BtnBloquearDesbloquear.vue?vue&type=template&id=55d7942e&"
import script from "./BtnBloquearDesbloquear.vue?vue&type=script&lang=js&"
export * from "./BtnBloquearDesbloquear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports